let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gnWSG")).then(() => parcelRequire('4Pup2'));